import { ChangeDetectionStrategy, Component, OnDestroy, inject, signal } from '@angular/core';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';

import { ImageConversionService } from '@shared/services/image-conversion/image-conversion.service';

@Component({
  selector: 'app-document-file-preview-modal',
  templateUrl: './document-file-preview-modal.component.html',
  styleUrls: ['./document-file-preview-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgxExtendedPdfViewerModule, RktIconComponent],
})
export class DocumentFilePreviewModalComponent implements OnDestroy {
  private imageConversion = inject(ImageConversionService);

  type = '';

  url = '';

  name = '';

  fileFormat!: 'JPG' | 'PNG' | 'PDF';

  readonly displayUrl = signal('');

  readonly loading = signal(false);

  readonly imageFailed = signal(false);

  ready?: Promise<void>;

  private objectUrl: string | null = null;

  constructor(public activeModal: ActiveModal) {}

  modalInitData({ type, url, name, fileFormat }: { url: string; type: string; name: string; fileFormat: 'JPG' | 'PNG' | 'PDF' }) {
    this.type = type;

    this.url = url;

    this.name = name;

    this.fileFormat = fileFormat;

    if (fileFormat === 'PDF') {
      return;
    }

    // HEIC images (often mislabeled .jpg) don't render outside Safari — convert to JPEG for viewing.
    this.loading.set(true);
    this.ready = this.imageConversion
      .toViewableUrl(url)
      .then((viewable) => {
        if (viewable.startsWith('blob:')) {
          this.objectUrl = viewable;
        }
        this.displayUrl.set(viewable);
      })
      .catch(() => this.displayUrl.set(url))
      .finally(() => this.loading.set(false));
  }

  onImageError(): void {
    this.imageFailed.set(true);
  }

  ngOnDestroy(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }
}
